import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { AddressService } from "../../../address/services/address.service";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { RadioModel } from "../../../shared/model/radio.model";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { TrackInfo } from "../../../shared/service/journey/tracks/model/track-info";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { ProfessionService } from "../../service/profession.service";

@Component({
  selector: "app-profession",
  templateUrl: "./profession.page.html",
  styleUrls: ["./profession.page.scss"],
})
export class ProfessionPageComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "profession";
  titlePage = "Dados profissionais";
  professionList = new Array<RadioModel>();
  selectedItem = "";
  selectedName = "";
  idLabel = "nationality";
  textSearch: string;
  fieldSearch = "value";
  @ViewChild("content") content: ElementRef;
  startStage = "";
  endStage = "";
  showRetry = false;
  loading = true;
  dataDomain: RadioModel[];
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;
  savePrevious = false;
  idLabelProfession = "idLabelProfession";
  idInputSearchProfession = "idInputSearchProfession";
  idRadioProfession = "idRadioProfession";
  idButtonProfession = "idButtonProfession";

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public professionService: ProfessionService,
    private addressService: AddressService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(undefined, DomainDataType.Profession);
    this.getTrack();
  }

  async ngOnInit() {
    this.setTitle();
    this.headerFocus();
    await this.getProfessionList();
    this.editFieldInvest("profissao_codigo", "profession", "professionalData");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "professional-data";
    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PROFESSIONAL
    ) {
      this.startStage = "3";
      this.endStage = "4";
    } else {
      this.startStage = track.getIndexPage(this.headerId, path).toString();
      this.endStage = track.getTotalPage(path).toString();
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  ionViewDidLeave() {
    this.textSearch = "";
    this.professionList = this.orderList(
      this.professionList,
      this.selectedItem
    );
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.profession;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathProfissao,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathProfissao,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    const save =
      this.journeyService.selectedTrack.track.findIndex(
        (page: TrackInfo) => page.pageId === "company-cnpj"
      ) > -1;
    const origin =
      this.journeyService.registratioJourney.data.professionalData.originIncome;

    this.sendAnalyticsFirstView = true;
    this.professionService.setProfessionName(this.selectedName, origin, save);
    this.professionService.setProfession(this.selectedItem, origin, save);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.profession,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  getProfessionList() {
    this.domainFactory
      .getDomainService(this.domainOrigin)
      .getDomains(this.domainDataType)
      .then((dominios) => {
        if (dominios?.length > 0) {
          this.professionList = this.orderList(
            dominios,
            this.journeyService.registratioJourney.data.professionalData
              ?.profession
          );
          this.showRetry = false;
          this.analyticsData();
          this.sendTrackGA4LoadPage();
        } else {
          this.showRetry = true;
          this.headerFocus();
          this.sendTrackGA4LoadPageError();
        }
      })
      .catch(() => {
        this.showRetry = true;
        this.sendTrackGA4LoadPageError();
      })
      .finally(() => {
        this.loading = false;
        this.headerFocus();
      });
  }

  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== "") {
      const dataOrder = data;
      dataOrder.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter((value) => value.key === selectedItem),
        ...dataOrder.filter((value) => value.key !== selectedItem),
      ];
    }
    return data;
  }

  backPage() {
    // Remover este block do if e incluir isso dentro da action,
    // se removermos a track da stack, ela volta certo
    // Estudar o melhor jeito para tirar as regras da pagina
    this.analyticsEventClique();
    if (!this.journeyService.selectedTrack.isUncoupled()) {
      this.setValuePrevious();
      if (
        this.journeyService.journey !== TrackTypes.BASIC &&
        !this.journeyService.edit &&
        this.journeyService.journey !== TrackTypes.BASIC_PROFESSIONAL &&
        this.journeyService.journey !== TrackTypes.UPDATE_PROFESSIONAL &&
        this.journeyService.journey !== TrackTypes.BASIC_V2 &&
        this.journeyService.journey !== TrackTypes.BASIC_PROFESSIONAL_V2
      ) {
        if (!this.addressService.addressInitalPostCode?.city) {
          return this.router.navigateBack(["address", "city"]);
        }
        if (
          !this.addressService.addressInitalPostCode?.state &&
          this.addressService.addressInitalPostCode?.city
        ) {
          return this.router.navigateBack(["address", "state"]);
        }
        if (
          !this.addressService.addressInitalPostCode?.district &&
          this.addressService.addressInitalPostCode?.city &&
          this.addressService.addressInitalPostCode?.state
        ) {
          return this.router.navigateBack(["address", "district"]);
        }
        if (
          this.addressService.addressInitalPostCode?.district &&
          this.addressService.addressInitalPostCode?.city &&
          this.addressService.addressInitalPostCode?.state
        ) {
          return this.router.navigateBack(["address", "adjunt"]);
        }
      } else {
        this.back();
      }
    } else {
      this.back();
    }
  }

  setEditPageRegistratio() {
    if (
      this.journeyService.registratioJourney.data.professionalData
        ?.profession &&
      this.journeyService.registratioJourney.data.professionalData
        ?.profession !== "0"
    ) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.professionalData.profession;
      this.selectedName =
        this.journeyService.registratioJourney.data.professionalData.professionName;
    }
    if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        !this.savePrevious) ||
      (this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL_V2 &&
        !this.savePrevious) ||
      (this.journeyService.journey === TrackTypes.UPDATE_PROFESSIONAL &&
        !this.savePrevious)
    ) {
      this.savePrevious = true;
      this.journeyService.registratioJourney.data.professionalData.professionPrevious =
        this.selectedItem;
      this.journeyService.registratioJourney.data.professionalData.professionNamePrevious =
        this.selectedName;
    }
  }

  scrollContentToTop() {
    setTimeout(() => this.content?.nativeElement.scrollTo(0, 0), 200);
  }

  setValuePrevious() {
    if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        this.savePrevious === true) ||
      (this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL_V2 &&
        this.savePrevious === true) ||
      (this.journeyService.journey === TrackTypes.UPDATE_PROFESSIONAL &&
        this.savePrevious === true)
    ) {
      this.savePrevious = false;
      this.journeyService.registratioJourney.data.professionalData.profession =
        this.journeyService.registratioJourney.data.professionalData.professionPrevious;
      this.journeyService.registratioJourney.data.professionalData.professionName =
        this.journeyService.registratioJourney.data.professionalData.professionNamePrevious;
    }
  }

  changeValue() {
    this.professionList = this.orderList(
      this.professionList,
      this.selectedItem
    );
  }
}
